import * as Yup from "yup";

export const seleccionUsuarioValidation = Yup.object({
  empleador: Yup.string().required("Campo obligatorio").nullable(),
});
